type CircularProgressbarProps = {
  value?: number;
  size?: number;
  color?: string;
  thickness?: number;
  variant?: "determinate" | "indeterminate";
};

const SIZE = 44;

export default function CircularProgressbar({
  value = 0,
  size = 40,
  color = "#00687F",
  thickness = 3.6,
  variant = "indeterminate",
}: CircularProgressbarProps): JSX.Element {
  const r = (SIZE - thickness) / 2;
  const circ = 2 * Math.PI * r;
  const strokePct =
    ((100 - cleanPercentage(variant === "indeterminate" ? 40 : value)) * circ) /
    100;

  return (
    <span
      style={{
        width: size,
        height: size,
        transform: variant === "indeterminate" ? undefined : "rotate(-90deg)",
      }}
      className={`inline-block ${variant === "indeterminate" ? "animate-spin" : ""}`}
    >
      <svg viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`}>
        <circle
          cx={SIZE}
          cy={SIZE}
          r={r}
          fill="transparent"
          stroke="#e0e0e0"
          strokeWidth={thickness}
        ></circle>
        <circle
          cx={SIZE}
          cy={SIZE}
          r={r}
          fill="transparent"
          stroke={color}
          strokeLinecap="round"
          strokeWidth={thickness}
          strokeDasharray={circ}
          strokeDashoffset={strokePct}
          className="transition-all"
        ></circle>
      </svg>
    </span>
  );
}

function cleanPercentage(percentage: number): number {
  const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0;
  const isTooHigh = percentage > 100;
  return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
}
